// extracted by mini-css-extract-plugin
module.exports = {"copyright":"Copyright_copyright__9hKT_"};